import React from 'react';
import { Check, Clock, Palette } from 'lucide-react';
import { Dialog, DialogContent } from '../ui/dialog';
import { useLanguage } from '../../context/LanguageContext';
import { ACCENTS, useTheme } from '../../context/ThemeContext';
import { primaryTextColor } from '../../lib/brandPrimary';
import OfficeModalHeader from './OfficeModalHeader';
import SessionTimerControl from './SessionTimerControl';
import { cn } from '../../lib/utils';
import './OfficeMobileHeaderSheet.css';

export default function OfficeMobileHeaderSheet({ open, onOpenChange, accent, onSelectAccent, sessionTimerProps }) {
  const { t } = useLanguage();
  const { resolved } = useTheme();
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="omhp-dialog">
      <div className="omhp-hero"><OfficeModalHeader layout="row" variant="square" icon={Palette} title={t('header.mobilePrefs')} description="Deixe o Office confortável para sua rotina." /></div>
      <div className="omhp-body">
        <section className="omhp-section" aria-label="Aparência">
          <h3 className="omhp-section-label"><Palette size={15} /> Aparência</h3>
          <p className="omhp-explanation">Escolha a cor de destaque do seu Office.</p>
          <span className="omhp-field-title">{t('header.themeColor')}</span>
          <div className="omhp-color-options">{ACCENTS.map(a => {
            const swatch = resolved === 'dark' ? a.swatchDark : a.swatchLight;
            return <button key={a.key} data-testid={`mobile-accent-${a.key}`} className={cn('omhp-color-option', accent === a.key && 'is-on')} onClick={() => onSelectAccent(a.key)} aria-pressed={accent === a.key}><span style={{ backgroundColor: swatch, color: primaryTextColor(swatch) }} aria-hidden="true">{accent === a.key && <Check size={13} />}</span>{a.label}</button>;
          })}</div>
        </section>
        <section className="omhp-section" aria-label="Sessão">
          <h3 className="omhp-section-label"><Clock size={15} /> Sessão e segurança</h3>
          <p className="omhp-explanation">Confira o tempo conectado e ajuste a saída automática pelo controle abaixo.</p>
          {sessionTimerProps?.active ? <div className="omhp-session-row"><div className="omhp-session-copy"><span className="omhp-action-title">{t('session.menuTitle')}</span><span className="omhp-action-hint">{t('session.loggedFor')}: {sessionTimerProps.elapsedLabel}{sessionTimerProps.limitMinutes > 0 ? ` · ${t('session.remaining')}: ${sessionTimerProps.remainingLabel}` : ''}</span></div><SessionTimerControl compact {...sessionTimerProps} /></div> : <p className="omhp-explanation">O controle de sessão fica disponível quando o acesso estiver ativo.</p>}
        </section>
        <p className="omhp-explanation">As páginas e funções ficam no menu completo. Estas preferências não alteram permissões da sua conta.</p>
      </div>
    </DialogContent>
  </Dialog>;
}
